import React, { memo } from 'react';
import './style.scss';

export default memo(({ children }) => (
    <div className="fm-big-item-row">
        <span className="fm-big-item-row__title">{children}</span>
    </div>
));
